<template>
  <vue-navigation-bar :options="navbarOptions" />
</template>

<script>
  import { processChannel } from '@/store/converters'

  export default {
    data () {
      return {
        navbarOptions: {
          elementId: 'main-navbar',
          isUsingVueRouter: true,
          mobileBreakpoint: 992,
          brandImagePath: './',
          brandImageAltText: 'brand-image',
          collapseButtonOpenColor: '#661c23',
          collapseButtonCloseColor: '#661c23',
          showBrandImageInMobilePopup: true,
          ariaLabelMainNav: 'Main Navigation',
          tooltipAnimationType: 'shift-away',
          menuOptionsLeft: [],
        },
        menuOptionsLeft: [
          {
            type: 'link',
            text: 'Media Ingest',
            iconLeft: '<i class="mdi mdi-book-open-page-variant"></i>',
            subMenuOptions: [
              {
                type: 'link',
                text: 'FTP Sources',
                path: { name: 'invoice-ver-one' },
                iconLeft: '<i class="mdi mdi-circle-medium"></i>',
              },
              {
                type: 'link',
                text: 'MRSS sources',
                path: { name: 'invoice-ver-two' },
                iconLeft: '<i class="mdi mdi-circle-medium"></i>',
              },
            ],
          },
          {
            type: 'link',
            text: 'On Air',
            iconLeft: '<i class="mdi mdi-view-dashboard fa-spin"></i>',
            path: { name: 'dashboard' },
          },
          {
            type: 'link',
            text: 'Assets',
            iconLeft: '<i class="mdi mdi-folder-table"></i>',
            subMenuOptions: [
              {
                type: 'link',
                text: 'VOD',
                path: { name: 'dataIterators' },
                iconLeft: '<i class="mdi mdi-circle-medium"></i>',
              },
              {
                type: 'link',
                text: 'Ads',
                path: { name: 'simpleTables' },
                iconLeft: '<i class="mdi mdi-circle-medium"></i>',
              },
            ],
          },
          {
            type: 'link',
            text: 'Settings',
            iconLeft: '<i class="mdi mdi-cogs"></i>',
            subMenuOptions: [
              {
                type: 'link',
                text: 'General',
                path: { name: 'button' },
                iconLeft: '<i class="mdi mdi-circle-medium"></i>',
              },
              {
                type: 'link',
                text: 'Schedule',
                path: { name: 'avatar' },
                iconLeft: '<i class="mdi mdi-circle-medium"></i>',
              },
              {
                type: 'link',
                text: 'Bug',
                path: { name: 'alerts' },
                iconLeft: '<i class="mdi mdi-circle-medium"></i>',
              },
            ],
          },
        ],
        dashboardMenu: {
          type: 'link',
          text: 'Dashboard',
          iconLeft: '<i class="mdi mdi-view-dashboard"></i>',
          path: { name: 'DashboardPage' },
        },
        channelMenu: null,
        channels: [],
      }
    },
    watch: {
      '$route' (to, from) {
        this.generateMenu(to)
      },
    },
    created () {
      this.$store.commit('setPageLoader')

      const channelReq = this.$store.dispatch('channels', {})
      Promise.all([channelReq])
        .then((result) => {
          const channels = result[0] || []
          if (channels.length) {
            const processedChannels = channels.map((c) => processChannel(c))
            this.channels = processedChannels
            const channelMenu = {
              type: 'link',
              text: 'Channels',
              iconLeft: '<i class="mdi mdi-play"></i>',
              subMenuOptions: [],
            }
            for (let i = 0; i < processedChannels.length; i += 1) {
              channelMenu.subMenuOptions.push(
                {
                  type: 'link',
                  text: processedChannels[i].name,
                  iconLeft: '<i class="mdi mdi-circle-medium"></i>',
                  path: '/channel/' + processedChannels[i].id + '/on-air',
                },
              )
            }
            this.channelMenu = channelMenu
          }
        })
        .catch((errorMsg) => {
          console.log('nav-bar error:', errorMsg)
        })
        .finally(() => {
          this.generateMenu(this.$route)
          this.$store.commit('resolvePageLoader')
        })
    },
    methods: {
      getChannelById (id) {
        for (let i = 0; i < this.channels.length; i += 1) {
          if (this.channels[i].id == id) {
            return this.channels[i]
          }
        }
        return {}
      },
      generateMenu (route) {
        this.navbarOptions.menuOptionsLeft = []
        this.navbarOptions.menuOptionsLeft.push(this.dashboardMenu)
        if (this.channelMenu) {
          this.navbarOptions.menuOptionsLeft.push(this.channelMenu)
        }
        if (route.params.id) {
          this.navbarOptions.menuOptionsLeft.push({
            type: 'link',
            text: 'Media Sources',
            iconLeft: '<i class="mdi mdi-file-upload-outline"></i>',
            path: '/channel/' + route.params.id + '/media-sources',
          })
          this.navbarOptions.menuOptionsLeft.push({
            type: 'link',
            text: 'Assets',
            iconLeft: '<i class="mdi mdi-format-list-bulleted"></i>',
            path: '/channel/' + route.params.id + '/assets',
          })
          this.navbarOptions.menuOptionsLeft.push({
            type: 'link',
            text: 'Ads',
            iconLeft: '<i class="mdi mdi-cash"></i>',
            path: '/channel/' + route.params.id + '/ads',
          })
          this.navbarOptions.menuOptionsLeft.push({
            type: 'link',
            text: 'Schedule',
            iconLeft: '<i class="mdi mdi-chart-timeline"></i>',
            subMenuOptions: [
              {
                type: 'link',
                text: 'Scheduler',
                iconLeft: '<i class="mdi mdi-calendar-text"></i>',
                path: '/channel/' + route.params.id + '/scheduler',
              },
              {
                type: 'link',
                text: 'Settings',
                iconLeft: '<i class="mdi mdi-cogs"></i>',
                path: '/channel/' + route.params.id + '/scheduler-settings',
              },
            ],
          })

          const outputSubMenu = [
            {
              type: 'link',
              text: 'On Air',
              iconLeft: '<i class="mdi mdi-play"></i>',
              path: '/channel/' + route.params.id + '/on-air',
            },
            {
              type: 'link',
              text: 'EPG',
              iconLeft: '<i class="mdi mdi-format-list-bulleted"></i>',
              path: '/channel/' + route.params.id + '/epg',
            },
          ]
          const channel = this.getChannelById(route.params.id)
          if (channel.version === 2) {
/*            outputSubMenu.push({
              type: 'link',
              text: 'Distributions',
              iconLeft: '<i class="mdi mdi-format-list-bulleted"></i>',
              path: '/channel/' + route.params.id + '/distributions',
            })*/
          }
          this.navbarOptions.menuOptionsLeft.push({
            type: 'link',
            text: 'Output',
            iconLeft: '<i class="mdi mdi-television-play"></i>',
            subMenuOptions: outputSubMenu,
          })
          this.navbarOptions.menuOptionsLeft.push({
            type: 'link',
            text: 'Settings',
            iconLeft: '<i class="mdi mdi-cogs"></i>',
            path: '/channel/' + route.params.id + '/edit',
          })
        }
      },
    },
  }
</script>

<style lang="scss">
.vnb {
  &__menu-options {
    &__option {
      &__link {
        &:focus {
          outline: none;
          border: 1px solid none;
        }
        &:hover {
          color: #0081ff;
          .vnb__menu-options__option__arrow {
            fill: #0081ff;
          }
        }

        &__icon {
          svg {
            fill: #0081ff !important;
          }
        }
      }
    }
  }

  &__sub-menu-options {
    &__option {
      &__link {
        &:focus {
          outline: none;
          border: 1px solid none;
        }
        color: #000 !important;
        &:hover {
          color: #0081ff !important;
        }
      }
    }
  }
}

.vnb__collapse-button {
  &:focus {
    border: 1px solid none;
    outline: none;
  }
  &:after {
    content: "\F035C";
    font-size: 25px;
    font-weight: 600;
    font-family: "Material Design Icons",serif;
  }
  svg {
    display: none !important;
  }
}

.vnb__popup {
  max-height: 80vh;
  overflow-x: hidden;
  overflow-y: scroll !important;
  .vnb__popup__top__close-button {
    &:focus {
      border: 1px solid none;
      outline: none;
    }
    top: 20px;
    right: -33px;
    svg {
      fill: #000 !important;
    }
  }
}
.vnb__sub-menu-options__option {
  max-height: 400px;
  overflow-y:auto;
}
</style>
